module.exports = __webpack_public_path__ + "static/media/H2U.43138591.jpg";